// extracted by mini-css-extract-plugin
module.exports = {"promoCountdown":"PromotionalCountdownTimer_promoCountdown__e9nMN"};